import { render, staticRenderFns } from "./CoTwoHmcForm.vue?vue&type=template&id=5f845efe&scoped=true&"
import script from "./CoTwoHmcForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoHmcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f845efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f845efe')) {
      api.createRecord('5f845efe', component.options)
    } else {
      api.reload('5f845efe', component.options)
    }
    module.hot.accept("./CoTwoHmcForm.vue?vue&type=template&id=5f845efe&scoped=true&", function () {
      api.rerender('5f845efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoHmcForm.vue"
export default component.exports